export default "__VITE_ASSET__BNq5Zg2o__"